module.exports = __webpack_public_path__ + "static/img/eboard-factory1_org.ac00977.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eboard-factory1_org.png
// module id = xyUK
// module chunks = 1